import React from "react";

const Menu = ({ color, ...props }) => (
  <svg viewBox="0 0 36.5 25" {...props}>
    <defs />
    <title>Menu Icon</title>
    <g>
      <g>
        <path
          className="cls-1"
          d="M1 1h34.5M1 12.5h34.5M1 24h34.5"
          stroke="currentColor"
          strokeWidth={2}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

export default Menu;



// WEBPACK FOOTER //
// ./src/icons/Menu.js